import React from "react";
import { OptionCard } from "./OptionCard";

export const RadioField = ({ question, value, onChange, lang }) => {
  const opts = question.options || [];
  if (!opts.length) return <div className="dq-empty">No options configured.</div>;
  const qStyle = question.config && question.config.option_style;
  const useGrid =
    !qStyle || (qStyle !== "compact" && qStyle !== "icon");
  return (
    <div
      className={useGrid ? "dq-options" : ""}
      style={
        useGrid
          ? undefined
          : {
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
              justifyContent: "center",
            }
      }
    >
      {opts.map((opt) => (
        <OptionCard
          key={opt.id}
          option={opt}
          selected={value === opt.id}
          onClick={() => onChange(opt.id)}
          lang={lang}
          questionStyle={qStyle}
        />
      ))}
    </div>
  );
};
